import {
  createContext,
  createElement,
  useMemo,
  FC,
  PropsWithChildren,
} from 'react';

type ErrorHandler = (error: unknown) => void;

const defaultErrorHandler: ErrorHandler = (err) => {
  // eslint-disable-next-line no-console
  console.error(err);
};

export const ErrorBoundaryContext = createContext<{
  handleError: ErrorHandler;
}>({
  handleError: defaultErrorHandler,
});

export const ErrorBoundaryProvider: FC<
  PropsWithChildren<{
    handleError?: ErrorHandler;
  }>
> = (
  // eslint-disable-next-line react/prop-types
  { children, handleError = defaultErrorHandler },
) => {
  return createElement(
    ErrorBoundaryContext.Provider,
    { value: useMemo(() => ({ handleError }), [handleError]) },
    children,
  );
};
